import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import {
  BriefAiApi,
  type OpenBriefBriefUpdateCommand,
  OpenBriefsApi,
} from "@/config/apiClient";
import { createApiClient } from "@/config/createApiClient";
import { currentWorkspaceAtom } from "@/store";

const apiClient = createApiClient(BriefAiApi);
const apiClientOpenBrief = createApiClient(OpenBriefsApi);

export const useOpenBrief = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const useGetReferentialProducts = () => {
    return useQuery({
      queryKey: [
        "getReferentialProducts",
        currentWorkspace?.accountId,
        currentWorkspace?.organizationId,
        currentWorkspace?.id,
      ],
      enabled: !!currentWorkspace,
      queryFn: () => {
        return apiClient.briefAiControllerGetProducts({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
        });
      },
    });
  };

  const useGetAttributes = (
    productId: number,
    options: { enabled?: boolean } = { enabled: true }
  ) => {
    return useQuery({
      queryKey: [
        "getAttributes",
        currentWorkspace?.accountId,
        currentWorkspace?.organizationId,
        currentWorkspace?.id,
        productId,
      ],
      enabled: !!currentWorkspace && !!productId && !!options?.enabled,
      queryFn: () => {
        return apiClient.briefAiControllerGetAttributes({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
          productAdmaId: `${productId}`,
        });
      },
    });
  };

  const useEditbrief = (briefId: string) => {
    return useMutation({
      mutationFn: (
        openBriefBriefUpdateCommand: OpenBriefBriefUpdateCommand
      ) => {
        return apiClientOpenBrief.openBriefsControllerUpdateBrief({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
          briefId,
          openBriefBriefUpdateCommand,
        });
      },
    });
  };

  return {
    useGetAttributes,
    useGetReferentialProducts,
    useEditbrief,
  };
};
